module.exports = __webpack_public_path__ + "static/media/add-vimeo.a21efacd.svg";